export default __webpack_public_path__ + "static/brianholland-214d2ac6adb159395c3342f18e18b191.jpg";